import * as ApiManager from './_manager';
import store from '@/store';

export const coupon = {
  create: (payload = null) => {
    return ApiManager.callApi(
      `/member/company/${store.getters['company/getSelected']}/coupon/create`,
      payload
    );
  },

  get: (payload = null) => {
    return ApiManager.callApi(
      `/member/company/${store.getters['company/getSelected']}/coupon/get`,
      payload
    );
  },

  list: payload => {
    return ApiManager.callApi(
      `/member/company/${store.getters['company/getSelected']}/coupon/list`,
      payload
    );
  },

  delete: payload => {
    return ApiManager.callApi(
      `/member/company/${store.getters['company/getSelected']}/coupon/${payload.id}/delete`,
      payload
    );
  },

  update: payload => {
    return ApiManager.callApi(
      `/member/company/${store.getters['company/getSelected']}/coupon/` +
        payload.id +
        `/update`,
      payload
    );
  },
  export: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/coupon/export`,
      payload
    );
  },
};
